<template>
  <section>
    <div class="card">
      <div class="card-header">
        <h4>Friendship price</h4>
      </div>
      <div class="card-body">
        <div class="alert alert-info">
          Der Preis einer Freundschaftsanfrage muss höher sein, als die der
          Starteinheiten.
        </div>
        <div class="form-group row">
          <div class="col-12">
            <toggle-switch
              label="Friendship price"
              type="success"
              v-model="data.friendshipPriceCheck"
            ></toggle-switch>
          </div>
        </div>
        <div class="form-group">
          <button @click="persist()" class="btn btn-primary">Speichern</button>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
export default {
  created() {
    this.$store.dispatch("setting/all").then(() => {
      this.data.friendshipPriceCheck = Boolean(
        this.$store.getters["setting/key"]("friendshipPriceCheck")
      );
    });
  },
  methods: {
    persist() {
      const data = Object.assign({}, this.data);
      this.$store.dispatch("setting/update", data).then(() => {
        this.$notify({
          title: "Einstellungen gespeichert",
          type: "success"
        });
      });
    }
  },
  data() {
    return {
      data: {
        friendshipPriceCheck: true
      }
    };
  }
};
</script>
